
<main>
    <div class="profile-details">
        <div class="contact-form">
            <form [formGroup]="ContactUsForm" (ngSubmit)="contactAdd()">
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="નામ " formControlName="person_name" />
                    <div *ngIf="submitted && f.person_name.errors" class="error-message">
                        <small *ngIf="f.person_name.errors?.required" class="text-danger">નામ
                            જરૂરી
                            છે.</small>
                    </div>
                </div>
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="સંપર્ક નંબર " maxlength="15"
                        formControlName="contact_number" />
                    <!-- <div *ngIf="submitted && f.contact_number.errors" class="error-message">
                        <small *ngIf="f.contact_number.errors?.required" class="text-danger">સંપર્ક નંબર
                            જરૂરી
                            છે.</small>
                    </div> -->
                    <div *ngIf="submitted && f.contact_number.errors" class="error-message">
                        <small *ngIf="f.contact_number.errors?.required" class="text-danger">સંપર્ક નંબર જરૂરી
                            છે.</small>
                    </div>
                    <div *ngIf="f.contact_number.errors?.pattern && f.contact_number.touched" class="error-message">
                        <small *ngIf="f.contact_number.errors?.pattern" class="text-danger">માત્ર નંબર જ માન્ય
                            છે.</small>
                    </div>
                    <div *ngIf="f.contact_number.errors?.minlength && f.contact_number.touched" class="error-message">
                        <small *ngIf="f.contact_number.errors?.minlength" class="text-danger">ઓછામાં ઓછા 7 નંબર જરૂરી
                            છે.</small>
                    </div>
                </div>
                <div class="form-group">
                    <textarea rows="5" class="form-control" placeholder="સંપર્ક માટેનું કારણ દાખલ કરો"
                        formControlName="description"></textarea>
                    <div *ngIf="submitted && f.description.errors" class="error-message">
                        <small *ngIf="f.description.errors?.required" class="text-danger">સંપર્ક માટેનું કારણ
                            જરૂરી
                            છે.</small>
                    </div>
                </div>
                <button type="submit" class="btn-common">સાચવો </button>
            </form>
        </div>
    </div>
</main>